import { put, takeEvery } from "redux-saga/effects";
import { createBrowserHistory } from "history";
import {
  FETCH_CHEMISTINVOICEDETAILS_INIT_ACTION,
  FETCH_CHEMISTINVOICEDETAILS_SUCCESS_ACTION,
  FETCH_CHEMISTINVOICEDETAILS_FAIL_ACTION,
  FETCH_CHEMISTINVOICESTATUSCHANGE_INIT_ACTION,
  FETCH_CHEMISTINVOICESTATUSCHANGE_SUCCESS_ACTION,
  FETCH_CHEMISTINVOICESTATUSCHANGE_FAIL_ACTION,
  FETCH_CHEMISTINVOICESEARCH_INIT_ACTION,
  FETCH_CHEMISTINVOICESEARCH_SUCCESS_ACTION,
  FETCH_CHEMISTINVOICESEARCH_FAIL_ACTION,
  FILTER_BY_CHEMISTINVOICE_STATUS_INIT_ACTION,
  FILTER_BY_CHEMISTINVOICE_STATUS_SUCCESS_ACTION,
  FILTER_BY_CHEMISTINVOICE_STATUS_FAIL_ACTION
} from "./action";

import { appConfig } from "../../config";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

function* fetchChemistInvoice(value) {
  const token = localStorage.getItem("token");
  let pageno = !value.value
    ? 1
    : value.value.page === undefined
    ? 1
    : value.value.page;

  let search = !value.value
    ? ""
    : value.value.search === ""
    ? ""
    : value.value.search;

  let filter = !value.value
    ? ""
    : value.value.filter === ""
    ? ""
    : value.value.filter;

  try {
    const res = yield fetch(
      `${appConfig.ip}/invoice?invType=chemist&search=${search}&status=${filter}&limit=10&page=${pageno}`,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      throw res;
    } else {
      const resJSON = yield res.json();
      yield put({
        type: FETCH_CHEMISTINVOICEDETAILS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CHEMISTINVOICEDETAILS_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* fetchChemistInvoiceStatusChange(data) {
  let datas;

  data.value.item.status === "paid"
    ? (datas = {
        status: "cancelled"
      })
    : (datas = {
        status: "paid"
      });

  const id = data.value.item.id;

  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(`${appConfig.ip}/invoice/changeStatus/` + id, {
      method: "PUT",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(datas)
    });
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield toast.success("Status changed successfully", {
        autoClose: 3000
      });
      yield put({
        type: FETCH_CHEMISTINVOICESTATUSCHANGE_SUCCESS_ACTION,
        payload: resJSON
      });

      const refreshParams =
        data &&
        data.value &&
        data.value.refreshParams
          ? data.value.refreshParams
          : undefined;
      yield put({
        type: FETCH_CHEMISTINVOICEDETAILS_INIT_ACTION,
        value: refreshParams
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FETCH_CHEMISTINVOICESTATUSCHANGE_FAIL_ACTION,
        error: err
      });
    } else {
    }
  }
}
function* fetchSearchChemistInvoice(value) {
  let searchVal = value.value.searchChemistInvoice;
  const token = localStorage.getItem("token");
  try {
    const res = yield fetch(
      `${appConfig.ip}/invoice?invType=chemist&&limit=10&page=` +
        value.value.Spage +
        "&search=" +
        searchVal,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FETCH_CHEMISTINVOICESEARCH_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_CHEMISTINVOICESEARCH_FAIL_ACTION, error: err });
    } else {
    }
  }
}

function* FliterSearchChemistInvoice(value) {
  const token = localStorage.getItem("token");

  try {
    const res = yield fetch(
      `${appConfig.ip}/invoice?invType=chemist&&limit=10&page=` +
        value.value.page +
        "&&status=" +
        value.value.value,
      {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
    );
    if (!res.ok) {
      let errJSON = {};
      try {
        errJSON = yield res.json();
      } catch {}
      throw Object.assign(res, errJSON);
    } else {
      const resJSON = yield res.json();

      yield put({
        type: FILTER_BY_CHEMISTINVOICE_STATUS_SUCCESS_ACTION,
        payload: resJSON
      });
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({
        type: FILTER_BY_CHEMISTINVOICE_STATUS_FAIL_ACTION,
        error: err
      });
    } else {
    }
  }
}

export function* ChemistInvoiceActionWatcher() {
  yield takeEvery(FETCH_CHEMISTINVOICEDETAILS_INIT_ACTION, fetchChemistInvoice);
  yield takeEvery(
    FETCH_CHEMISTINVOICESTATUSCHANGE_INIT_ACTION,
    fetchChemistInvoiceStatusChange
  );
  yield takeEvery(
    FETCH_CHEMISTINVOICESEARCH_INIT_ACTION,
    fetchSearchChemistInvoice
  );
  yield takeEvery(
    FILTER_BY_CHEMISTINVOICE_STATUS_INIT_ACTION,
    FliterSearchChemistInvoice
  );
}

